import Container from '@/components/Container/Container'
import { ExplicitHead } from '@/components/DefaultHead/DefaultHead'
import Mail from '@/components/Mail/Mail'
import Main from '@/components/Main/Main'
import Header from '@/components/SimpleHeader/SimpleHeader'

const DESTINATION = 'bugreport@edhrec.com'

const BugReport = () => (
  <Main>
    <Container small>
      <ExplicitHead
        description='Report a bug to the EDHREC team'
        keywords='EDHREC,bug,error,issue,report'
        title='Bug Report | EDHREC'
      />
      <Header>Report a Bug</Header>
      <Mail
        description={
          <p>
            {'Use the form below, or email us at '}
            <a href={`mailto:${DESTINATION}`} rel='noreferrer' target='_blank'>
              {DESTINATION}
            </a>
            .
          </p>
        }
        destination={DESTINATION}
      />
    </Container>
  </Main>
)

export default BugReport
